import React from 'react';
import { useSelector } from 'react-redux';
import Profile from '../assets/SVG/icons/Avatar.svg';
import BackIcon from '../assets/SVG/buttons/back-button.svg';
import '../styles/header.css';
import { useHistory } from 'react-router-dom';

function Header({ backRoute = null }) {
    const user = useSelector(state => state.user);
    const history = useHistory();

    const goToProfile = () => history.push('/navigation');

    const goToBack = () => backRoute ? history.push(backRoute) : history.goBack();

    return (
        <div className='header mt-3' data-testid="header">
            <img src={BackIcon} alt='goback-cta' onClick={goToBack} data-testid="goback-cta"/>
            <img src={user?.picture? user.picture : Profile} className="profileIcon mt-4" alt="Profile" onClick={goToProfile} data-testid="navigation-cta"/>
            <span className='dummy'></span>
        </div>
    )
}

export default Header;
